let redirect_uri = "http://h5.courtws.cn/judgeAuthorize"

// if(!window.location.origin.includes('localhost')){
//   redirect_uri = window.location.origin+'/login'
// }
let config = {
  fileUrl:'http://h5.courtws.cn/api/',
  APPID: "wwaea6f98a625769ee",
  redirect_uri: redirect_uri,
  agentid:'1000059',//蕉城
  originRouteFrom:{
    path:'',
    query:{}
  },
}
export default config;


// WEBPACK FOOTER //
// ./src/utils/config.js